import React from "react";
import { LoadingDialog } from "../../../helper/LoadingDialog";

export function VendorLoadingDialog({ isLoading }) {
  return <LoadingDialog isLoading={isLoading} text="Loading ..." />;
}
